import api from '../client'
import { toTaskOption } from '../../features/project-management/common/pmOptionUtils'

export async function fetchTaskOptions(search = '', page = 1, pageSize = 20, projectId = null) {
  const params = {
    search,
    page,
    page_size: pageSize,
    includeTotal: false,
    archive: false,
    fromDate: '1900-01-01',
    toDate: '9999-12-31',
  }
  if (projectId && projectId !== 'All' && projectId !== 'all') {
    params.project_id = Number(projectId)
  }
  const { data } = await api.get('/tasks/', { params })
  const rawItems = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : []
  const items = rawItems.map(toTaskOption).filter(Boolean)
  const hasMore = rawItems.length === pageSize
  return { items, hasMore }
}

